import React from 'react';
import PropTypes from "prop-types";
import {InfoIcon} from "presentation/common/components/style-guide/icons";
import {Button} from "presentation/common/components";
import styles from './CancelledPaymentMessage.module.scss';
import clsx from "clsx";
import {emptyFn} from "presentation/common/helpers/utils";

export const CancelledPaymentMessageContent = (props) => {
  const {message, title, Icon = InfoIcon, onClose} = props;

  return (
    <div className={styles.container}>
      <div className="text-center mb-0 lg:mb-3"><Icon /></div>
      <div className="pb-2 lg:pb-0">
        <h3 className={clsx("text-lg text-center lg:pt-1 pb-1", styles.title)}>{title}</h3>
        <p className={clsx("text-center pb-8", styles.message)}>{message}</p>
      </div>

      <div className="text-center">
        <Button label="Aceptar" onClick={onClose}/>
      </div>
    </div>
  );
};

CancelledPaymentMessageContent.defaultProps = {
  title: '¡Solicitud cancelada!',
  message: 'La solicitud no será procesada porque el pago fue cancelado.',
  onClose: emptyFn,
};

CancelledPaymentMessageContent.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  onClose: PropTypes.func,
};

export default React.memo(CancelledPaymentMessageContent);
